export default __webpack_public_path__ + "static/media/showcase-vacations.33bc41ea.jpg";